import ColComp from './Col';
export default ColComp;
